import { graphql } from '@/gql';

export const allProductGroups = graphql(`
  query allProductGroups {
    productGroups {
      id
      owner
      businessUnit
      name
      description
      createdAt
      updatedAt
      members {
        id
        name
      }
    }
  }
`);

export const createProductGroup = graphql(`
  mutation createProductGroup($createProductGroupInput: CreateProductGroupInput!) {
    createProductGroup(createProductGroupInput: $createProductGroupInput) {
      id
    }
  }
`);

export const updateProductGroup = graphql(`
  mutation updateProductGroup($updatedProductGroup: UpdateProductGroupInput!) {
    updateProductGroup(updatedProductGroup: $updatedProductGroup) {
      id
    }
  }
`);

export const deleteProductGroup = graphql(`
  mutation deleteProductGroup($id: ID!) {
    deleteProductGroup(id: $id) {
      id
    }
  }
`);
